import type { Location, To } from "react-router-dom";
import { Routes } from "../constants";

export type AllianceDetailLocationState = {
  returnTo?: string;
};

export function currentReturnTo(
  location: Pick<Location, "pathname" | "search">,
) {
  return `${location.pathname}${location.search}`;
}

export function allianceDetailTo(id: string, returnTo: string): To {
  return {
    pathname: `/savezi/${id}`,
    state: { returnTo } satisfies AllianceDetailLocationState,
  };
}

export function resolveBackToSearch(location: Location): string | number {
  const returnTo = (location.state as AllianceDetailLocationState | null)
    ?.returnTo;
  if (returnTo) return returnTo;
  if (typeof window !== "undefined" && window.history.length > 1) return -1;
  return Routes.ALLIANCES;
}
